import React from "react";
import { useNavigate } from 'react-router-dom';
import { Button, Card, Container, Alert } from 'react-bootstrap';

function ResetPasswordSuccess() {
  const navigate = useNavigate();

  return (
    <Container
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh" }}>
      <Card
        className="shadow"
        style={{ maxWidth: "400px", width: "100%", borderRadius: "10px" }}>
        <Card.Body className="text-center">
          <h2>Password Reset Successful!</h2>
          <div className="text-center mb-4">
            <img
              src="/faithwelcomeback.png"
              alt="Welcome"
              style={{ maxWidth: "100%", height: "auto", borderRadius: "8px" }}
            />
          </div>
          <Alert variant="success">
            Your password has been reset successfully.
          </Alert>
          <div className="d-grid gap-2 mt-4">
            <Button 
              variant="primary" 
              className="rounded-pill btn-accent"
              onClick={() => navigate("/login")}
            >
              Back to Login Page
            </Button>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default ResetPasswordSuccess; 